import { defineComponent, createElementBlock, openBlock, normalizeClass, createBlock, normalizeProps, mergeProps } from "vue";
import _sfc_main$4 from "./index3.js";
import _sfc_main$3 from "./index4.js";
/* empty css       */
import _sfc_main$2 from "./index6.js";
/* empty css       */
import _sfc_main$1 from "./index8.js";
import _sfc_main$5 from "./index9.js";
/* empty css        */
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Receipt",
  props: {
    order: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => {
      }
    },
    venue: {
      type: Object,
      default: () => void 0
    },
    isRetail: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      var _a, _b, _c, _d, _e;
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["receipt", { a4: (_a = __props.options) == null ? void 0 : _a.forceA4Format }])
      }, [
        ((_b = __props.order) == null ? void 0 : _b.isCreditNote()) ? (openBlock(), createBlock(_sfc_main$1, normalizeProps(mergeProps({ key: 0 }, _ctx.$props)), null, 16)) : ((_c = __props.order) == null ? void 0 : _c.isEinvoice()) ? (openBlock(), createBlock(_sfc_main$2, normalizeProps(mergeProps({ key: 1 }, _ctx.$props)), null, 16)) : ((_d = __props.order) == null ? void 0 : _d.rendersManualInvoice()) ? (openBlock(), createBlock(_sfc_main$3, normalizeProps(mergeProps({ key: 2 }, _ctx.$props)), null, 16)) : ((_e = __props.options) == null ? void 0 : _e.forceA4Format) ? (openBlock(), createBlock(_sfc_main$4, normalizeProps(mergeProps({ key: 3 }, _ctx.$props)), null, 16)) : (openBlock(), createBlock(_sfc_main$5, normalizeProps(mergeProps({ key: 4 }, _ctx.$props)), null, 16))
      ], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=index61.js.map
